module.exports = __webpack_public_path__ + "img/about-case2.d9510331.jpg";